import { message } from 'antd';
import i18n from '../i18n';
import { putWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

interface CredentialType {
  id: number;
}

export const handleUpdateCredential = async (data: any, credential: CredentialType, onOk?: () => void) => {
  console.log('handleUpdateCredential data', data, credential);
  if (!credential.id) return;

  try {
    const response = await putWithCSRF(envApiUrl + '/credentials', data, {
      headers: {
        id: credential.id,
      },
    });
    console.log('Update credential: response: ', response);
    message.success(i18n.t('passwords.credentialUpdated'));
    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('handleUpdateCredential error: ', err.response?.data?.message, err.response);
    message.error(err.response?.data?.message || i18n.t('passwords.credentialUpdateFailed'));
  }
};
